import React from 'react';
import users from '../assets/add-users.svg';
import Nav from './Nav';
import { Link } from 'react-router-dom';

class Sidebar extends React.Component{
    render(){
        return(
            <div>
                <Nav/>
                <div className="side-bar">
                    <Link to="/add-user">
                        <div className="tabs">
                            <img src={users} alt="" />
                            <h6>Add User</h6>
                        </div>
                    </Link>
                </div>
            </div>
        )
    }
}

export default Sidebar;


// WEBPACK FOOTER //
// ./src/components/Sidebar.js